import React from 'react';
import { Button } from '../components/Button';
import { ProgressBar } from '../components/questions/ProgressBar';
import { QuestionBlock } from '../components/questions/QuestionBlock';
import { QUESTIONS_PER_PAGE } from '../data/questions';
import type { AnswerMap, AnswerValue, Question } from '../types/assessment';
type QuestionsProps = {
  page: number;
  totalPages: number;
  totalQuestions: number;
  pageQuestions: Question[];
  answers: AnswerMap;
  answeredCount: number;
  validationMessage: string;
  onAnswer: (id: number, value: AnswerValue) => void;
  onNext: () => void;
  onBack: () => void;
};
export function Questions({
  page,
  totalPages,
  totalQuestions,
  pageQuestions,
  answers,
  answeredCount,
  validationMessage,
  onAnswer,
  onNext,
  onBack
}: QuestionsProps) {
  const start = page * QUESTIONS_PER_PAGE;
  const rangeLabel = `Questions ${start + 1}–${start + pageQuestions.length} of ${totalQuestions}`;
  const isLastPage = page === totalPages - 1;
  return <div className="mx-auto w-full max-w-reading px-6 pb-24" data-id="element-93" data-mp="2b7jnbuj3z07b">
      <ProgressBar rangeLabel={rangeLabel} answered={answeredCount} total={totalQuestions} data-id="element-94" data-mp="2b82tyf3b6261" />

      <p className="py-5 font-display text-xs uppercase tracking-[0.1em] text-ink-muted" data-id="element-95" data-mp="26aji1lu321h9">
        Answer with your first instinct
      </p>

      <div className="space-y-3" data-id="element-96" data-mp="2g75ze0n7aaej">
        {pageQuestions.map((question, index) => <QuestionBlock key={question.id} question={question} index={start + index + 1} total={totalQuestions} value={answers[question.id]} onChange={value => onAnswer(question.id, value)} data-id="element-97" data-mp="2tyatkn7suahh" data-mpi={index} />)}
      </div>

      {validationMessage && <p role="alert" className="pt-4 text-[13px] text-[#b94040]" data-id="element-98" data-mp="2yx46oej6bzh4">
          {validationMessage}
        </p>}

      <div className="flex flex-col-reverse gap-2.5 pt-6 sm:flex-row sm:items-center" data-id="element-99" data-mp="19j8tmt77q4r7">
        <Button variant="quiet" onClick={onBack} data-id="element-100" data-mp="14keec18geybu">
          ← {page === 0 ? 'Back to start' : 'Previous'}
        </Button>
        <Button onClick={onNext} data-id="element-101" data-mp="34n6vqbney6uk">{isLastPage ? 'See My Results →' : 'Continue →'}</Button>
      </div>

      <p className="pt-4 text-xs text-ink-muted" data-id="element-102" data-mp="39l8m7hn658g2">
        Your answers are saved on this device as you go, so you can close this and come back.
      </p>
    </div>;
}